(function () {
  'use strict';

  document.querySelectorAll('.video-lightbox-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', openLightbox);
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') openLightbox.call(trigger, e);
    });
  });

  function openLightbox(e) {
    e.preventDefault();

    var trigger = this;
    var type = trigger.dataset.videoType;
    var section = trigger.closest('.video-section');
    var modal = section.querySelector('.video-lightbox-modal');
    var player = modal.querySelector('.video-lightbox-player');
    var prerender = section.querySelector('.video-lightbox-prerender');

    player.innerHTML = '';

    if (type === 'shopify') {
      var vid = prerender.querySelector('video');
      if (vid) {
        var clone = vid.cloneNode(true);
        clone.autoplay = true;
        clone.muted = false;
        clone.removeAttribute('hidden');
        player.appendChild(clone);
        clone.play().catch(function () {});
      }
    } else {
      var iframeTpl = prerender.querySelector('iframe');
      if (iframeTpl) {
        var iframe = iframeTpl.cloneNode(true);
        iframe.src = iframe.dataset.src;
        iframe.removeAttribute('data-src');
        player.appendChild(iframe);
      }
    }

    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';

    modal.querySelector('.video-lightbox-close').onclick = function () {
      closeLightbox(modal, player);
    };
    modal.querySelector('.video-lightbox-overlay').onclick = function () {
      closeLightbox(modal, player);
    };
    document._lbKeyHandler = function (ev) {
      if (ev.key === 'Escape') closeLightbox(modal, player);
    };
    document.addEventListener('keydown', document._lbKeyHandler);
  }

  function closeLightbox(modal, player) {
    var vid = player.querySelector('video');
    if (vid) { vid.pause(); vid.currentTime = 0; }
    var iframe = player.querySelector('iframe');
    if (iframe) { iframe.src = ''; }

    player.innerHTML = '';
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', document._lbKeyHandler);
  }
})();
